import React, { useEffect, useState } from "react";
import parse, { domToReact } from "html-react-parser";
import { useDispatch, useSelector } from "react-redux";
import { ApplicationState } from "../../store";
import * as ConfigurationActions from "../../store/configurationService/actions";

const CCPA = () => {
    const dispatch = useDispatch();
    const [state, setState] = useState({ isLoading: true, content: "" });
    const footerLogoHTML: any = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerProvider
            ? state.configurationState.configuration.partnerConfig.footerLogoHTML
            : ""
    );
    const routeLoading = useSelector((state: ApplicationState) => state.configurationState && (state.configurationState.loading || false));

    let authData = useSelector((state: ApplicationState) => {
        if (state.creditAuthData.authData != null) {
            return {
                isIDFUser: state.creditAuthData.authData.isIDFUser,
                partnerId: state.loggedInUser?.userInfo?.partnerID,
                status: state.creditAuthData.authData["status-code"],
            };
        }
        return { isIDFUser: "", partnerId: 36, status: "" };
    });

    let partnerData = useSelector((state: ApplicationState) => {
        if (state.configurationState?.configuration?.partnerConfig != null) {
            let { email, partnerId, phoneNumber } = state.configurationState.configuration.partnerConfig;
            return {
                email: email,
                phoneNumber: phoneNumber,
                partnerId: partnerId,
            };
        }
        return {
            email: "",
            phoneNumber: "",
            partnerId: 36,
        };
    });

    const options = {
        replace: ({ attribs, children }: any) => {
            if (!attribs) return;

            if (attribs.hasOwnProperty("id") && attribs.id === "phone_ccpa" && partnerData.phoneNumber) {
                return (
                    <span id="phone_ccpa">
                        <a href={"tel:" + partnerData.phoneNumber}>{partnerData.phoneNumber}</a>
                    </span>
                );
            }

            if (attribs.hasOwnProperty("href")) {
                if (attribs.href.indexOf("window.print()") !== -1) {
                    return <a href="javascript:window.print();">{domToReact(children, options)}</a>;
                }

                if (
                    attribs.href.indexOf("privacy-policy") !== -1 ||
                    attribs.href.indexOf("canadian-privacy-policy") !== -1 ||
                    attribs.href.indexOf("PrivacyPolicy") !== -1
                )
                    return (
                        <a href="/privacy" target="_blank">
                            {domToReact(children, options)}
                        </a>
                    );

                if (attribs.href.indexOf("TermsAndConditions") !== -1 || attribs.href.indexOf("terms-of-use") !== -1)
                    return (
                        <a href="/terms" target="_blank">
                            {domToReact(children, options)}
                        </a>
                    );

                if (attribs.href.indexOf("EUUSPrivacyShield") !== -1 || attribs.href.indexOf("privacy-shield-policy") !== -1)
                    return (
                        <a href="/privacy-shield" target="_blank">
                            {domToReact(children, options)}
                        </a>
                    );

                if (
                    attribs.href.indexOf("EU-USPrivacyShield") !== -1 ||
                    attribs.href.indexOf("EUGDPRNotice") !== -1 ||
                    attribs.href.indexOf("eu-gdpr-fair-processing-notice") !== -1
                )
                    return (
                        <a href="/gdpr" target="_blank">
                            {domToReact(children, options)}
                        </a>
                    );

                if (attribs.href.indexOf(window.location.hostname) === -1)
                    return (
                        <a href={attribs.href} target="_blank" rel="noreferrer">
                            {domToReact(children, options)}
                        </a>
                    );
            }
        },
    };

    const callAPI = (url: string, data: any): Promise<any> => {
        return fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                PartnrID: data.PartnerID,
                ModuleCustomSettingsId: data.ModuleCustomSettingsId,
            },
            body: JSON.stringify(data),
        });
    };

    useEffect(() => {
        const url = "api/GetPartnerCustomHtml/GetPartnerCustomHtml";
        const data: any = {
            ModuleCustomSettingsId: 12357,
        };
        callAPI(url, data)
            .then((res: any): any => res.json())
            .then((res: any): any => {
                if (res["hasError"] === false && res["legalDocuments"].length) {
                    setState({
                        isLoading: false,
                        content: res["legalDocuments"][0].value,
                    });
                }
            })
            .catch((error: Error): any => console.log(error));
    }, [setState]);

    useEffect(() => {
        if (routeLoading) {
            dispatch(ConfigurationActions.actionCreators.setRouteLoading(false));
        }
    }, [dispatch, routeLoading]);

    return (
        <React.Fragment>
            <div className="faux-main-container">
                <div className=" row">
                    <div className="col-xs-12"></div>
                </div>

                {/* <!-- Page Content --> */}
                <div className="row" id="content">
                    <div className="col-xs">
                        <div className="box box-has-shadow">
                            {state.isLoading ? (
                                <div className="box-content loading"></div>
                            ) : (
                                <div className="box-content">
                                    {authData.isIDFUser && <h2>CCPA Addendum</h2>}
                                    {!!authData && authData.status !== "200" && <h2>CCPA Addendum</h2>}
                                    {parse(state.content, options)}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                <div className="logo-container" dangerouslySetInnerHTML={{ __html: footerLogoHTML }}></div>
            </div>
        </React.Fragment>
    );
};

export default CCPA;
